var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('audit-log-table',{attrs:{"title":"Logs"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }